import React, 
       { useEffect, 
         useState }                 from 'react';
import { Container, 
         Button,
         Row, 
         Col}                   from 'react-bootstrap';
import api                          from './AxiosConfig';
import { BsFillCaretDownFill,
         BsFillCaretUpFill     }    from 'react-icons/bs';
import EditCheckBox                 from './EditCheckBox';
import DateDisplay                  from './DateDisplay';

function GoalProgressUpdateDC( { selGoal, refresh } ) {
  const [startRecord, setStartRecord] = useState( 0 );
  const [goal,        setGoal]        = useState();
  const [progress,    setProgress]    = useState();
  const [message,     setMessage]     = useState( "" );
  const [messageErr,  setMessageErr]  = useState( false );

 useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
        }
  }, [selGoal]); // Runs when initialData changes

  useEffect(() => {
      async function getGoalProgress() {
          if ( goal && goal.id ) {
              try {
                  const response = await api.get(`/site/goals/progress/current/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  // Determine the value for startRecord
                  var sr = 0;
                  for ( let pr of response.data) {
                      if ( pr.is_measured !== 1 ) {
                          break;
                      }
                      sr = sr + 1;
                  }
                  if ( sr > 9 ) { 
                         sr = sr - 8; 
                  } else { 
                         sr = 0; 
                  }
                  setProgress(response.data);
                  setStartRecord( sr );
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      // Fetch the progress record for this goal.
      getGoalProgress();
  }, [goal]); 
 
  const updateProgressAtIndex = (i, newValue) => {
      setProgress(prev =>
          prev.map((item, idx) =>
          idx === i
          ? { ...item, is_checked: newValue, is_measured: "1" }   
          : item                           
          )
  );
};      
  const handleClick = (i) => {
      if (progress[i].is_checked === "1") {
          updateProgressAtIndex( i, "0" );
      } else {
          updateProgressAtIndex( i, "1" );
      }
  }

  const handleUpdateProgressRecord = async () => {
       try {
           const response = await api.put(`/site/goals/progress/${encodeURIComponent(goal.id)}`, { progress }, {withCredentials: true });
           setMessage(response.data.message);
           setMessageErr(!response.data.success);
           refresh();
       } catch (error) {
           console.log("subGoalRow: " + error);
           setMessage(error);
           setMessageErr( true );
       }
  }

  const handleButtonUp = async () => {
      if ( startRecord < 10 ) {
          setStartRecord( 0 );
      } else {
          setStartRecord( startRecord - 10 );
      }
  }

  const handleButtonDown = async () => {
      if ( startRecord < ( progress.length - 10 ) ) {
          setStartRecord( startRecord + 10 );
      } else {
          if ( progress.length < 10 ) {
              setStartRecord( 0 );
          }
      }
  }
       
  return (
    <Container className="mt-4">
      { goal && progress ? ( 
      <>
        {progress.map((pr, index) =>
            index >= startRecord && index < (startRecord + 10) && (
                <Row key={index}>
                  <Col className="text-end"><DateDisplay dateVal={pr.date} /></Col>
                  <Col><EditCheckBox index={index} boxMeasured={pr.is_measured} boxChecked={pr.is_checked} onBoxClick={handleClick} /></Col>
                  <Col>({pr.score && pr.score.toFixed(2)})</Col>
                </Row>
                )
              )}             
              <Row>
              <Col className="text-center"><Button variant="primary" size="sm" onClick={()=> handleButtonUp()}><BsFillCaretUpFill /></Button></Col>
              <Col className="text-center"><Button variant="primary" size="sm" onClick={() => handleUpdateProgressRecord()}>Update Progress</Button></Col>
              <Col className="text-center"><Button variant="primary" size="sm" onClick={()=> handleButtonDown()}><BsFillCaretDownFill /></Button></Col>
              </Row>
      </> ) : ( <p>Loading data...</p> )}
      <Row><Col className={'text-center message-err-' + messageErr}>{message}</Col></Row>
    </Container>           
  );
}

export default GoalProgressUpdateDC;
